<template>
  <div class="container-maestros">
      <div class="container container-fade">
        <div class="row">

          <div class="col-12 align-self-center d-block d-md-none text-center">
            <img width="80%" :src="`${publicPath}assets/images/maestros.png`" />
          </div>

          <div class="col-12 col-md-6">
            <div class="linea mt-5 mb-3">
              <h2 class="mb-3">{{ article.story.maestros.title }}</h2>
            
            </div>
            
            <div class="row mt-3">

              <div class="col-12">
               <div v-html="article.story.maestros.descripcion"></div>
              </div>

              <div class="col-12 col-md-12">
                <div class="text-center mb-3 linea ">
                </div>
              </div>

            </div>
          </div>
          <div class="col-12 col-md-5 offset-md-1 align-self-center d-none d-md-block">
            <div>
              <img width="100%" :src="`${publicPath}assets/images/maestros.png`" />
            </div>
          </div>
        </div>        
        <div class="row">
          <div class="col-12 col-md-8">
            <NominadosList :nominados="nominados" />
          </div>                   
        </div>


      </div>

    </div>
</template>

<script>

  import filter from 'lodash/filter'

  import NominadosList from '@/components/NominadosList'

  export default {
    name: 'Maestros',
    props: {
      nominados_list: []
    },
    components: {
      NominadosList
    },
    data () {
      return {
        publicPath: process.env.BASE_URL
      }
    },
    computed: {
      article() {
        return require(`@/i18n/es.json`)
      },
      nominados() {
        return filter(this.nominados_list, ['category_id', 'maestros'])
      }
    }
  }
</script>
